import Base from 'app/views/base';
import { List as ListView, Heading } from 'app/components/list/list';
import FulfillmentBolLineItems from 'app/collections/fulfillment_bol_line_items';
import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'fulfillment_bol_details',
  initialize() {
    this.collection = new FulfillmentBolLineItems(this.model.get('line_items'));
    const warehousesCollection = this.model.collection && this.model.collection.warehouses;
    this.warehouseAddress = warehousesCollection ?
      warehousesCollection.findWhere({ id: this.model.get('warehouse').id }).get('address') :
      this.model.get('warehouse').get('address');

    const headings = [
      new Heading({
        text: m => m.get('product').barcode,
        display: 'Barcode',
        xsSize: 7,
        smSize: 5,
        mdSize: 4,
      }),
      new Heading({
        property: 'units',
        display: 'Units Shipped',
        xsSize: 3,
        smSize: 2,
        mdSize: 2,
      }),
      new Heading({
        text: m => m.get('received_units') || 0,
        display: 'Units Received',
        xsSize: 2,
        smSize: 2,
        mdSize: 3,
      }),
      new Heading({
        text: m => {
          if (this.model.last_item_received_at()) {
            return m.discrepancy();
          }
          return 'N/A';
        },
        display: 'Discrepancy',
        smSize: 3,
        mdSize: 3,
      }),
    ];
    this.addSubview('bolDetailList', '.product-details', new ListView({
      headings,
      collection: this.collection,
      user: this.user,
      noResultsMessage: 'No products found in this BOL',
      wrapperClass: 'm-0',
    }));
  },
  afterRender() {
    this.collection.trigger('sync');
  },
  context() {
    return {
      warehouse: this.warehouseAddress.cityState(),
      trackingCode: this.model.get('tracking_code'),
      bolURL: this.model.get('url'),
      estimatedDelivery: this.model.estimated_delivery() || '',
    };
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/fulfillment_bols/details/index.js